import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { Avatar, AvatarFallback, AvatarImage } from './ui/avatar';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from './ui/dropdown-menu';
import { Badge } from './ui/badge';
import {
  Menu,
  X,
  ChevronDown,
  ArrowRight,
  Check,
  Server,
  Star,
  Crown,
  Globe,
  RefreshCw,
  Search,
  Layers,
  MonitorSmartphone,
  Palette,
  ShoppingCart,
  Mail,
  ShieldCheck,
  Users,
  Cpu,
  Database,
  Lock,
  Tag,
  Shield,
  BadgeCheck,
  Target,
  Rocket,
  Megaphone,
  BookOpen,
  FileText,
  GraduationCap,
  HelpCircle,
  Info,
  AlertCircle,
  CheckCircle,
  XCircle,
  AlertTriangle,
  Bell,
  Calendar,
  Clock,
  Cloud,
  Copy,
  Download,
  Upload,
  ExternalLink,
  Heart,
  Gift,
  Briefcase,
  Package,
  Truck,
  CreditCard,
  DollarSign,
  BarChart,
  TrendingUp,
  Award,
  Bookmark,
  Flag,
  Code,
  Terminal,
  Grid,
  List,
  Filter,
  Share2,
  Send,
  Paperclip,
  MessageCircle,
  MessageSquare,
  Video,
  Mic,
  Camera,
  Folder,
  File,
  Lightbulb,
  Key,
  Wifi,
  Activity,
  Repeat,
  Home,
  Phone,
  MapPin,
  Settings,
  Zap
} from 'lucide-react';
import MenuCard from './MenuCard';
import axios from 'axios';


const FixedMegaMenuHeader = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeMegaMenu, setActiveMegaMenu] = useState(null);
  const [menus, setMenus] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openMobileSubMenu, setOpenMobileSubMenu] = useState(null);
  const [navbarLogoUrl, setNavbarLogoUrl] = useState('');

  const apiBase = process.env.NODE_ENV === 'development' ? 'http://localhost:8000' : '';

  // Fetch menus from database
  useEffect(() => {
    const fetchMenus = async () => {
      try {
        const response = await axios.get(`${apiBase}/backend/api.php?action=getPublicMenus&type=navbar`);
        if (response.data.status === 'success') {
          const menusData = response.data.data || [];
          // Ensure boolean fields are properly converted
          const processedMenus = menusData.map(menu => ({
            ...menu,
            is_list_format: menu.is_list_format === true || menu.is_list_format === 1 || menu.is_list_format === '1',
            is_header: menu.is_header === true || menu.is_header === 1 || menu.is_header === '1',
            is_mega_menu: menu.is_mega_menu === true || menu.is_mega_menu === 1 || menu.is_mega_menu === '1',
            is_active: menu.is_active === true || menu.is_active === 1 || menu.is_active === '1',
            has_tabs: menu.has_tabs === true || menu.has_tabs === 1 || menu.has_tabs === '1'
          }));
          
          // Sort menus by order_index
          processedMenus.sort((a, b) => {
            if (a.order_index !== b.order_index) {
              return a.order_index - b.order_index;
            }
            // Aynı order_index ise id'ye göre sırala
            return a.id - b.id;
          });
          
          setMenus(processedMenus);
          
        }
      } catch (error) {
        // Silently handle error
      } finally {
        setLoading(false);
      }
    };
    fetchMenus();
  }, [apiBase]);

  // Fetch navbar logo from footer settings (navbar_logo_url > logo_url > default)
  useEffect(() => {
    const fetchNavbarLogo = async () => {
      try {
        const response = await axios.get(`${apiBase}/backend/admin_api.php?action=getFooterSettings`);
        const data = response.data;
        if (data && data.status === 'success' && data.data) {
          const fs = data.data;
          const url = fs.navbar_logo_url || fs.logo_url || '/website-al-koyu.png';
          setNavbarLogoUrl(url);
        } else {
          setNavbarLogoUrl('/website-al-koyu.png');
        }
      } catch (error) {
        setNavbarLogoUrl('/website-al-koyu.png');
      }
    };

    fetchNavbarLogo();
  }, [apiBase]);

  // Close mega menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.mega-menu-container')) {
        setActiveMegaMenu(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const megaMenuData = {
    domain: {
      title: 'Domain',
      columns: [
        [
          { name: 'Domain Sorgulama', path: '/alan-adi', description: "0,99$'dan başlayan fiyatlarla" }
        ]
      ],
      right: {
        title: 'Domain Hizmetleri',
        links: [
          { label: 'Satılık Alan Adları', path: '/domain-sorgulama/satilik-domain' },
          { label: '.COM Domain Kayıt', path: '/domain-sorgulama/com-domain-kayit' },
          { label: 'Toplu Domain Sorgulama', path: '/domain-sorgulama/toplu-domain-sorgulama' },
          { label: 'Whois Sorgulama', path: '/domain-sorgulama/whois-sorgulama' },
          { label: 'Domain Backorder', path: '/domain-sorgulama/domain-backorder' },
          { label: 'Domain Değerleme Aracı', path: '/domain-degerleme-araci' }
        ]
      }
    },
    website: {
      title: 'Web Sitesi',
      columns: [
        [
          { name: 'Kurumsal Web Sitesi', path: '/kurumsal-web-sitesi', description: 'Markanıza özel profesyonel kurumsal web sitesi çözümleri' },
          { name: 'Kurumsal Site Tasarımları', path: '/web-sitesi-tasarimlari', description: 'Profesyonel kurumsal web sitesi tasarımlarını keşfedin' },
          { name: 'Kolay Site', path: '/kolay-site', description: 'Yüzlerce profesyonel web tasarımı arasından seçin' },
          { name: 'Kolay Site Tasarımları', path: '/hazir-web-sitesi-tasarimlari', description: 'Kolay Site\'ye özel ücretsiz tasarım önerileri ile sitenizi birkaç tıkla yayınlayın.' },
          { name: 'E-Ticaret', path: '/eticaret', description: 'Profesyonel e-ticaret çözümleri ve paketleri' },
          { name: 'E-Ticaret Tasarımları', path: '/web-sitesi-tasarimlari', description: 'Profesyonel e-ticaret tasarım çözümleri' }
        ]
      ],
      right: {
        promo: {
          titleLines: ['Kolay Site', 'Web Oluşturucu'],
          features: ['Yapay Zeka Destekli', 'Profesyonel Tasarımlar', 'Ücretsiz Alan Adı'],
          priceOriginal: '3,99$',
          price: '0,69$/ay',
          cta: { label: 'İndirimli Satın Al', path: '/kolay-site' }
        }
      }
    },
    hosting: {
      title: 'Hosting',
      tabs: {
        domain: {
          title: 'Domain',
          order: 0,
          items: [
            { name: 'Domain Sorgulama', path: '/alan-adi', description: "0,99$'dan başlayan fiyatlarla" }
          ]
        },
        hosting: {
          title: 'Hosting',
          order: 1,
          items: [
            { name: 'Sınırsız Web Hosting', path: '/hosting', description: "0,69$'dan başlayan fiyatlarla" },
            { name: 'WordPress Hosting', path: '/wordpress-hosting', description: "0,99$'dan başlayan fiyatlarla" },
            { name: 'E-Ticaret Hosting', path: '/eticaret-hosting', description: 'Hazır sanal-pos entegrasyonu ile.' },
            { name: 'Bayi Hosting', path: '/bayi-hosting', description: 'Müşterilerinize hosting hizmeti verin' }
          ]
        },
        ssl: {
          title: 'SSL',
          order: 2,
          items: [
            { name: 'Tüm SSL Sertifikaları', path: '/ssl/ssl-sertifikasi', description: "15,99$'a anında kurulum hemen teslim SSL Sertifikası" },
            { name: 'Hızlı Kurulum (DV) SSL', path: '/ssl/ssl-sertifikasi#hizlikurulum', description: 'Belgesiz, anında kurulum SEO dostu SSL sertifikası' },
            { name: 'Kurumsal (OV) SSL', path: '/ssl/ssl-sertifikasi#premiumSsl', description: 'Kurulum belgelerinin yer aldığı, yüksek sigortalı SSL Sertifikası' },
            { name: 'Gelişmiş Kurumsal (EV) SSL', path: '/ssl/ssl-sertifikasi#evSsl', description: 'Yüksek güvenlik ve kapsamlı doğrulama sunan SSL Sertifikası' }
          ]
        },
        server: {
          title: 'Sunucu',
          order: 3,
          items: [
            { name: 'VPS Server', path: '/vps-sunucu', description: 'Sanal sunucuda ekonomik ve esnek çözümler' },
            { name: 'VDS Server', path: '/vds-sunucu', description: '29,99$/Ay Sanallaştırmada yüksek performans için en iyi çözüm' },
            { name: 'Kurumsal Server', path: '/kurumsal-sunucu', description: 'Kurumsal performans, en yüksek kaynak' }
          ]
        }
      },
      right: {
        promo: {
          titleLines: ['Jet Hızında', 'Başlangıç Hosting'],
          features: ['1 Adet Web Sitesi', '10 GB SSD Disk Alanı', '500 GB Trafik', 'Ücretsiz Site Alan Adı'],
          price: '0,69$/ay',
          cta: { label: 'İndirimli Satın Al', path: '/hosting' }
        }
      }
    },
    server: {
      title: 'Sunucu',
      columns: [
        [
          { name: 'VPS Server', path: '/vps-sunucu', description: 'Sanal sunucuda ekonomik ve esnek çözümler' },
          { name: 'VDS Server', path: '/vds-sunucu', description: '29,99$/Ay Sanallaştırmada yüksek performans için en iyi çözüm' },
          { name: 'Kurumsal Server', path: '/kurumsal-sunucu', description: 'Kurumsal performans, en yüksek kaynak' }
        ]
      ],
      right: {
        title: 'Sunucu Hizmetleri',
        links: [
          { label: 'Tüm Sunucular', path: '/sunucu-kiralama' },
          { label: 'Sunucu Destek', path: '/sunucu-kiralama/sunucu-server-destek' },
          { label: 'Sunucu Güvenliği', path: '/sunucu-kiralama/firewall-guvenlik' },
          { label: 'Sanal Sunucu Çözümleri', path: '/sanal-sunucu' }
        ]
      }
    },
    ssl: {
      title: 'SSL',
      columns: [
        [
          { name: 'Tüm SSL Sertifikaları', path: '/ssl/ssl-sertifikasi', description: "15,99$’a anında kurulum hemen teslim SSL Sertifikası" },
          { name: 'Hızlı Kurulum (DV) SSL', path: '/ssl/ssl-sertifikasi#hizlikurulum', description: 'Belgesiz, anında kurulum SEO dostu SSL sertifikası' },
          { name: 'Kurumsal (OV) SSL', path: '/ssl/ssl-sertifikasi#premiumSsl', description: 'Kurulum belgelerinin yer aldığı, yüksek sigortalı SSL Sertifikası' },
          { name: 'Gelişmiş Kurumsal (EV) SSL', path: '/ssl/ssl-sertifikasi#evSsl', description: 'Yüksek güvenlik ve kapsamlı doğrulama sunan SSL Sertifikası' }
        ]
      ],
      right: {
        title: 'SSL Hizmetleri',
        links: [
          { label: 'SSL Fiyatları', path: '/ssl/ssl-sertifikasi' },
          { label: 'PCI-DSS Taraması', path: '/ssl/pci-dss-guvenlik-taramasi' },
          { label: 'SEO için SSL', path: '/ssl/ssl-sertifikasi' },
          { label: 'SSL Sorgulama Aracı', path: '/ssl-checker' }
        ]
      }
    },
    marketing: {
      title: 'Pazarlama',
      columns: [
        [
          { name: 'SEO Hizmetleri', path: '/seo-hizmetleri', description: 'Organik görünürlük ve içerik stratejileri' },
          { name: 'Reklam Yönetimi', path: '/reklam-yonetimi', description: 'Performans odaklı dijital reklam kampanyaları' }
        ]
      ],
      right: {
        promo: {
          titleLines: ['Pazarlama', 'Strateji Paketi'],
          features: ['Teknik SEO Analizi', 'Google & Meta Reklam Yönetimi', 'Aylık Performans Raporu'],
          priceOriginal: null,
          price: 'Ücretsiz Ön Analiz',
          cta: { label: 'Danışmanlık Al', path: '/pazarlama-hizmetleri' }
        }
      }
    }
  };

  // Handle logout


  const handleMegaMenuClick = (menuKey) => {
    setActiveMegaMenu(activeMegaMenu === menuKey ? null : menuKey);
  };

  // Dinamik stil oluşturucu (hex veya Tailwind class)
  const getMenuStyle = (menu) => {
    const style = {};
    const classes = [];
    
    // Metin rengi
    if (menu.text_color) {
      if (menu.text_color.startsWith('#')) {
        style.color = menu.text_color;
      } else if (menu.text_color.startsWith('text-')) {
        classes.push(menu.text_color);
      }
    }
    
    // Arka plan rengi
    if (menu.bg_color) {
      if (menu.bg_color.startsWith('#')) {
        style.backgroundColor = menu.bg_color;
      } else if (menu.bg_color.startsWith('bg-')) {
        classes.push(menu.bg_color);
      }
    }
    
    return { style, classes: classes.join(' ') };
  };

  // Hover renkleri için data attribute
  const getHoverAttrs = (menu) => {
    const attrs = {};
    if (menu.hover_color) {
      attrs['data-hover-color'] = menu.hover_color;
    }
    if (menu.hover_bg_color) {
      attrs['data-hover-bg'] = menu.hover_bg_color;
    }
    return attrs;
  };

  // Tailwind renk class'ını hex'e çevir
  const tailwindToHex = (tailwindClass, shade = '600') => {
    const colorMap = {
      'purple-600': '#9333ea', 'purple-700': '#7e22ce',
      'blue-600': '#2563eb', 'blue-700': '#1d4ed8',
      'indigo-600': '#4f46e5', 'indigo-700': '#4338ca',
      'green-600': '#16a34a', 'green-700': '#15803d',
      'emerald-600': '#059669', 'emerald-700': '#047857',
      'rose-600': '#e11d48', 'rose-700': '#be185d',
      'pink-600': '#db2777', 'pink-700': '#be185d',
      'orange-600': '#ea580c', 'orange-700': '#c2410c',
      'amber-600': '#d97706', 'amber-700': '#b45309',
      'yellow-600': '#ca8a04', 'yellow-700': '#a16207',
      'cyan-600': '#0891b2', 'cyan-700': '#0e7490',
      'teal-600': '#0d9488', 'teal-700': '#0f766e'
    };
    
    // hover:text-purple-600 -> purple-600 -> #9333ea
    const match = tailwindClass.match(/(purple|blue|indigo|green|emerald|rose|pink|orange|amber|yellow|cyan|teal)-(\d+)/);
    if (match) {
      const key = `${match[1]}-${match[2]}`;
      return colorMap[key] || '#9333ea';
    }
    return '#9333ea';
  };

  // Parent menüden kart buton rengini hesapla
  const getCardButtonColors = (parentMenu) => {
    if (!parentMenu || !parentMenu.hover_color) {
      return { buttonBg: '#9333ea', buttonHover: '#7e22ce' };
    }
    
    // hover:text-purple-600 -> #9333ea
    const buttonBg = tailwindToHex(parentMenu.hover_color, '600');
    const buttonHover = tailwindToHex(parentMenu.hover_color.replace('-600', '-700'), '700');
    
    return { buttonBg, buttonHover };
  };

  const renderMega = (menuKey) => {
    // Get menu from database - try menu_key first, then fallback to title-based key
    const parentMenu = menus.find(m => {
      const mKey = m.menu_key || m.title.toLowerCase().replace(/\s+/g, '');
      const menuKeyLower = menuKey.toLowerCase();
      const mKeyLower = mKey.toLowerCase();
      return (mKeyLower === menuKeyLower || m.title.toLowerCase() === menuKeyLower) && m.parent_id === null && m.is_mega_menu;
    });
    
    // Özel sekme yapısı kontrolü - has_tabs kontrolü ile
    // Eğer hosting_tabs varsa, has_tabs true kabul et (geriye dönük uyumluluk için)
    const hasTabsExplicit = parentMenu?.has_tabs === true || parentMenu?.has_tabs === 1 || parentMenu?.has_tabs === '1';
    const hasTabsData = parentMenu?.hosting_tabs && (typeof parentMenu.hosting_tabs === 'object' || (typeof parentMenu.hosting_tabs === 'string' && parentMenu.hosting_tabs.trim() !== ''));
    const hasTabs = hasTabsExplicit || hasTabsData;
    
    // Eğer has_tabs true ise veya hosting_tabs varsa, sekme yapısını kullan
    let customTabs = null;
    let rightData = null;
    
    // hosting_tabs varsa parse et (has_tabs false olsa bile)
    if (parentMenu?.hosting_tabs) {
      let parsedTabs = null;
      if (typeof parentMenu.hosting_tabs === 'string') {
        try {
          parsedTabs = JSON.parse(parentMenu.hosting_tabs);
        } catch (e) {
          console.error('Error parsing hosting_tabs:', e, 'Raw data:', parentMenu.hosting_tabs);
          parsedTabs = null;
        }
      } else {
        parsedTabs = parentMenu.hosting_tabs;
      }
      
      // hosting_tabs yapısı: { tabs: {...}, right: {...} }
      if (parsedTabs) {
        if (parsedTabs.tabs && typeof parsedTabs.tabs === 'object') {
          customTabs = parsedTabs.tabs;
        } else if (typeof parsedTabs === 'object' && !parsedTabs.tabs) {
          // Eğer direkt tabs objesi ise (eski format veya yanlış format)
          // Her key'in bir tab olup olmadığını kontrol et
          const hasTabStructure = Object.values(parsedTabs).some(v => 
            v && typeof v === 'object' && (v.title || v.items)
          );
          if (hasTabStructure) {
            customTabs = parsedTabs;
          }
        }
        
        if (parsedTabs.right) {
          rightData = parsedTabs.right;
        }
      }
    }
    
    // Özel sekme yapısı - has_tabs true ise veya hosting için fallback
    // menuKey kontrolü: 'hosting' veya title 'Hosting' ise
    const isHostingMenu = menuKey === 'hosting' || 
                         menuKey.toLowerCase() === 'hosting' || 
                         (parentMenu && parentMenu.title && parentMenu.title.toLowerCase() === 'hosting');
    
    // Eğer has_tabs true ise, hosting_tabs varsa, veya hosting menüsü ise sekme yapısını kullan
    if (hasTabs || hasTabsData || (isHostingMenu && !parentMenu) || (isHostingMenu && parentMenu && parentMenu.hosting_tabs)) {
      // Önce veritabanından hosting_tabs'ı kontrol et
      let tabsData = customTabs;
      
      // Eğer has_tabs true veya hosting_tabs varsa ama tabs yoksa, normal mega menu göster
      if ((hasTabs || hasTabsData) && (!tabsData || Object.keys(tabsData).length === 0)) {
        console.warn('has_tabs is true or hosting_tabs exists but no tabs data found');
        return null; // Normal mega menu render'ına geç
      }
      
      // Hosting için fallback to hardcoded data (sadece has_tabs false ise)
      if (isHostingMenu && !hasTabs && (!tabsData || Object.keys(tabsData).length === 0)) {
        tabsData = megaMenuData.hosting?.tabs;
      }
      
      if (!tabsData || Object.keys(tabsData).length === 0) {
        // Eğer hosting değilse ve tabs yoksa, normal mega menu göster
        if (!isHostingMenu) {
          return null; // Normal mega menu render'ına geç
        }
        // Hosting için hardcoded fallback (sadece has_tabs false ise)
        if (!hasTabs) {
          console.warn('Tabs not found, using hardcoded fallback');
          tabsData = megaMenuData.hosting?.tabs;
        } else {
          return null;
        }
      }
      
      if (!tabsData) {
        return null;
      }
      
      // Fallback to hardcoded data for hosting (sadece has_tabs false ise)
      if (isHostingMenu && !hasTabs && !rightData) {
        rightData = megaMenuData.hosting?.right || null;
      }
      
      const hostingData = {
        tabs: tabsData,
        right: rightData
      };
      
      return (
        <div className="absolute top-full left-0 right-0 w-screen bg-white shadow-2xl border-t border-gray-100 max-h-[min(85vh,800px)] flex flex-col">
          <div className="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-8 py-6 flex-1 min-h-0 overflow-y-auto">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
              <div className="col-span-12 lg:col-span-9">
                {/* Tüm sekmeler alt alta ve açık */}
                <div className="space-y-8">
                  {(() => {
                    // Sekmeleri order'a göre sırala (order yoksa 0 kabul et)
                    const sortedTabs = Object.keys(hostingData.tabs).map(tabKey => ({
                      key: tabKey,
                      tab: hostingData.tabs[tabKey],
                      order: hostingData.tabs[tabKey]?.order ?? 0
                    })).sort((a, b) => a.order - b.order);
                    
                    return sortedTabs.map(({ key: tabKey, tab }) => {
                      if (!tab) {
                        return null;
                      }
                      // items kontrolü - eğer yoksa boş array yap
                      if (!tab.items) {
                        tab.items = [];
                      }
                      if (!Array.isArray(tab.items)) {
                        tab.items = [];
                      }
                      // Icon ve renk için menuKey belirleme
                      // Hosting için özel mapping, diğerleri için tabKey veya parent menu_key kullan
                      let menuKeyForIcon = menuKey;
                      if (isHostingMenu) {
                        menuKeyForIcon = tabKey === 'domain' ? 'domain' : (tabKey === 'ssl' ? 'ssl' : (tabKey === 'server' ? 'server' : 'hosting'));
                      } else {
                        // Diğer mega menüler için tabKey'i kullan veya parent menu_key
                        menuKeyForIcon = tabKey;
                      }
                    
                    // Tab için ikon ve renkleri belirle
                    const TabIcon = tab.icon ? getIconComponentByName(tab.icon) : null;
                    
                    // Tab için renkleri belirle (tab'dan, parent'tan veya default)
                    const getTabIconColor = () => {
                      if (tab.icon_color) {
                        if (tab.icon_color.startsWith('text-')) {
                          return tab.icon_color;
                        } else if (tab.icon_color.startsWith('#')) {
                          return { color: tab.icon_color };
                        }
                      }
                      return getIconColor(menuKeyForIcon);
                    };
                    
                    const getTabHoverBgClass = () => {
                      if (tab.hover_bg_color) {
                        if (tab.hover_bg_color.startsWith('hover:bg-')) {
                          return tab.hover_bg_color;
                        } else if (tab.hover_bg_color.startsWith('#')) {
                          // Hex renk için inline style kullan
                          return '';
                        }
                      }
                      return getHoverBgClass(menuKeyForIcon);
                    };
                    
                    const getTabHoverBgStyle = () => {
                      if (tab.hover_bg_color && tab.hover_bg_color.startsWith('#')) {
                        return { '--hover-bg-color': tab.hover_bg_color };
                      }
                      return {};
                    };
                    
                    const getTabTitleColor = () => {
                      if (tab.title_color) {
                        if (tab.title_color.startsWith('text-')) {
                          return tab.title_color;
                        } else if (tab.title_color.startsWith('#')) {
                          return { color: tab.title_color };
                        }
                      }
                      return 'text-gray-900';
                    };
                    
                    const iconColor = getTabIconColor();
                    const hoverBgClass = getTabHoverBgClass();
                    const hoverBgStyle = getTabHoverBgStyle();
                    const titleColor = getTabTitleColor();
                    const titleColorStyle = typeof titleColor === 'object' ? titleColor : {};
                    const titleColorClass = typeof titleColor === 'string' ? titleColor : '';
                    
                    return (
                      <div key={tabKey} className="space-y-4">
                        {/* Sekme Başlığı */}
                        <h3 
                          className={`text-lg font-bold ${titleColorClass}`}
                          style={titleColorStyle}
                        >
                          {tab.title || tabKey}
                        </h3>
                        
                        {/* Sekme İçeriği - Kartlar */}
                        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 gap-4">
                          {tab.items.map((item, idx) => {
                            // Icon öncelik sırası:
                            // 1) item.icon (admin'den gelen)
                            // 2) getItemIcon (menuKey + isim bazlı dinamik)
                            // 3) TabIcon (sekme için genel ikon)
                            const ItemIcon =
                              (item.icon ? getIconComponentByName(item.icon) : null) ||
                              getItemIcon(menuKeyForIcon, item.name) ||
                              TabIcon ||
                              getItemIcon(menuKeyForIcon, item.name);
                            
                            // Icon rengi - Önce item.icon_color, sonra tab.icon_color, sonra default
                            const getItemIconColor = () => {
                              // Önce item'ın kendi icon_color'unu kontrol et
                              if (item.icon_color) {
                                if (item.icon_color.startsWith('text-')) {
                                  return item.icon_color;
                                } else if (item.icon_color.startsWith('#')) {
                                  return { color: item.icon_color };
                                }
                              }
                              // Sonra tab'ın icon_color'unu kullan
                              return iconColor;
                            };
                            
                            const itemIconColorValue = getItemIconColor();
                            // Hover durumunda da aynı rengi kullan - CSS ile override
                            let itemIconColor;
                            if (typeof itemIconColorValue === 'object') {
                              // Inline style kullanılıyorsa, hover'da da aynı rengi koru
                              itemIconColor = { 
                                style: { ...itemIconColorValue },
                                className: 'w-9 h-9'
                              };
                            } else {
                              // Tailwind class kullanılıyorsa, hover'da da aynı rengi korumak için CSS variable kullan
                              // Tailwind class'ından renk çıkar ve CSS variable olarak kullan
                              const colorMap = {
                                'text-gray-700': '#374151',
                                'text-white': '#ffffff',
                                'text-gray-900': '#111827',
                                'text-purple-600': '#9333ea',
                                'text-blue-600': '#2563eb',
                                'text-indigo-600': '#4f46e5',
                                'text-emerald-600': '#059669',
                                'text-green-600': '#16a34a',
                                'text-rose-600': '#e11d48',
                                'text-pink-600': '#db2777',
                                'text-orange-600': '#ea580c',
                                'text-amber-600': '#d97706',
                                'text-yellow-600': '#ca8a04',
                                'text-cyan-600': '#0891b2',
                                'text-teal-600': '#0d9488'
                              };
                              const colorHex = colorMap[itemIconColorValue] || '#374151';
                              itemIconColor = { 
                                className: `w-9 h-9 ${itemIconColorValue}`,
                                style: { 
                                  '--icon-color': colorHex,
                                  color: colorHex
                                }
                              };
                            }
                            
                            // Hover bg style - hover'da ikon rengi beyaz olacak, arka plan ikon rengi ile aynı
                            const iconColorHex = typeof itemIconColorValue === 'object' && itemIconColorValue.color 
                              ? itemIconColorValue.color 
                              : (itemIconColor.style?.['--icon-color'] || itemIconColor.style?.color || '#374151');
                            
                            // Hover arka plan rengi ikon rengi ile aynı olacak
                            return (
                              <Link
                                key={idx}
                                to={item.path || '#'}
                                onClick={() => setActiveMegaMenu(null)}
                                className={`group border border-gray-100 rounded-lg p-5 transition-colors text-center ${hoverBgClass} [&:hover_svg]:!text-white`}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.backgroundColor = iconColorHex;
                                  e.currentTarget.style.borderColor = iconColorHex;
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.backgroundColor = '';
                                  e.currentTarget.style.borderColor = '';
                                }}
                              >
                                <div className="mx-auto flex items-center justify-center">
                                  <ItemIcon 
                                    className={itemIconColor.className} 
                                    style={{ color: iconColorHex, ...(itemIconColor.style || {}) }}
                                  />
                                </div>
                                <div className="mt-3 text-sm font-semibold text-gray-900 group-hover:text-white">
                                  {item.name}
                                </div>
                                {item.description && (
                                  <p className="mt-2 text-xs text-gray-600 group-hover:text-white/90">{item.description}</p>
                                )}
                              </Link>
                            );
                          })}
                        </div>
                      </div>
                      );
                    });
                  })()}
                </div>
              </div>
              
              {/* Sağ taraf - Liste/Kart formatı ve Promo kartı */}
              <div className="col-span-12 lg:col-span-3 mt-4 lg:mt-0 space-y-4">
                {/* Sağ taraf alt menüleri (rightChildren) */}
                {(() => {
                  // Get right children from database
                  const rightChildren = menus
                    .filter(m => 
                      m.parent_id === parentMenu?.id && 
                      m.mega_menu_section === 'right'
                    )
                    .sort((a, b) => {
                      if (a.order_index !== b.order_index) {
                        return a.order_index - b.order_index;
                      }
                      return a.id - b.id;
                    });
                  
                  // is_list_format kontrolü
                  const isListFormat = parentMenu ? (
                    parentMenu.is_list_format === true || 
                    parentMenu.is_list_format === 1 || 
                    parentMenu.is_list_format === '1'
                  ) : false;
                  
                  if (rightChildren.length > 0) {
                    if (isListFormat) {
                      // Liste formatı
                      return (
                        <div className="hidden lg:block">
                          {/* Başlık öğeleri (is_header = true) */}
                          {rightChildren.filter(item => item.is_header).map((item) => {
                            const headerClass =
                              item.text_color && item.text_color.startsWith('text-')
                                ? item.text_color
                                : (parentMenu?.text_color || 'text-gray-900');
                            return (
                              <div key={item.id} className={`text-sm font-semibold mb-2 ${headerClass}`}>
                                {item.title}
                              </div>
                            );
                          })}
                          {/* Liste öğeleri (is_header = false) */}
                          <div className="space-y-2">
                            {rightChildren.filter(item => !item.is_header).map((item) => {
                              const baseTextClass =
                                item.text_color && item.text_color.startsWith('text-')
                                  ? item.text_color
                                  : (parentMenu?.text_color || 'text-gray-600');
                              const hoverClass =
                                item.hover_color && item.hover_color.startsWith('hover:')
                                  ? item.hover_color
                                  : (parentMenu?.hover_color || 'hover:text-purple-600');
                              return (
                                <Link 
                                  key={item.id} 
                                  to={item.url || '#'} 
                                  onClick={() => setActiveMegaMenu(null)} 
                                  className={`flex items-center text-sm ${baseTextClass} ${hoverClass}`}
                                >
                                  <ArrowRight className="w-3 h-3 mr-2" />
                                  {item.title}
                                </Link>
                              );
                            })}
                          </div>
                        </div>
                      );
                    } else {
                      // Kart formatı - İlk kart öğesini göster
                      const rightCardMenu = rightChildren.find(item => item.promo_data || item.is_promo_card) || rightChildren[0];
                      if (rightCardMenu && (rightCardMenu.promo_data || rightCardMenu.is_promo_card)) {
                        return (
                          <MenuCard 
                            menu={rightCardMenu} 
                            colors={{
                              ...rightCardMenu.promo_data?.colors,
                              ...(parentMenu ? getCardButtonColors(parentMenu) : {})
                            }}
                          />
                        );
                      }
                    }
                  }
                  
                  // Eğer rightChildren yoksa veya kart formatında kart bulunamadıysa, ana menünün promo_data'sını göster
                  if (!isListFormat && parentMenu?.promo_data) {
                    return (
                      <MenuCard 
                        menu={parentMenu} 
                        colors={{
                          ...parentMenu.promo_data?.colors,
                          ...(parentMenu ? getCardButtonColors(parentMenu) : {})
                        }}
                      />
                    );
                  }
                  
                  return null;
                })()}
                
                {/* Promo kartı (hosting_tabs.right.promo) */}
                {hostingData.right?.promo && (
                  <MenuCard 
                    menu={{
                      title: hostingData.right.promo.titleLines?.[1] || '',
                      url: hostingData.right.promo.cta?.path || '#',
                      promo_data: {
                        upperTitle: hostingData.right.promo.titleLines?.[0] || null,
                        features: hostingData.right.promo.features || [],
                        priceOriginal: hostingData.right.promo.priceOriginal || null,
                        price: hostingData.right.promo.price || null,
                        cta: hostingData.right.promo.cta || { label: '', path: '#' },
                        colors: hostingData.right.promo.colors || {}
                      }
                    }}
                    colors={{
                      ...(hostingData.right.promo.colors || {}),
                      ...(parentMenu ? getCardButtonColors(parentMenu) : {})
                    }}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      );
    }
    
    // Parent menüden default renkleri al
    const getParentColor = (field, defaultValue = null) => {
      if (!parentMenu) return defaultValue;
      return parentMenu[field] || defaultValue;
    };
    
    // Get children from database and sort by order_index
    const leftChildren = menus
      .filter(m => 
        m.parent_id === parentMenu?.id && 
        (m.mega_menu_section === null || m.mega_menu_section === '' || m.mega_menu_section !== 'right')
      )
      .sort((a, b) => {
        if (a.order_index !== b.order_index) {
          return a.order_index - b.order_index;
        }
        return a.id - b.id;
      });
    const rightChildren = menus
      .filter(m => 
        m.parent_id === parentMenu?.id && 
        m.mega_menu_section === 'right'
      )
      .sort((a, b) => {
        if (a.order_index !== b.order_index) {
          return a.order_index - b.order_index;
        }
        return a.id - b.id;
      });
    
    // Fallback to hardcoded data if no database data
    const data = parentMenu ? null : megaMenuData[menuKey];
    
    // is_list_format kontrolü: boolean veya 1/0 olabilir
    // 0 veya false = kart formatı, 1 veya true = liste formatı
    const isListFormat = parentMenu ? (
      parentMenu.is_list_format === true || 
      parentMenu.is_list_format === 1 || 
      parentMenu.is_list_format === '1'
    ) : false;
    
    // Kart formatında: Ana menünün kendi kart verilerini kullan veya sağ taraftaki ilk kart öğesini bul
    // Liste formatında: Sağ taraftaki tüm link öğelerini göster
    const rightCardMenu = parentMenu && !isListFormat 
      ? (parentMenu.promo_data ? parentMenu : rightChildren.find(item => item.promo_data || item.is_promo_card))
      : null;
    
    return (
      <div className="absolute top-full left-0 right-0 w-screen bg-white shadow-2xl border-t border-gray-100 max-h-[min(85vh,800px)] flex flex-col">
        <div className="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-8 py-6 flex-1 min-h-0 overflow-y-auto">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
            <div className="col-span-12 lg:col-span-9">
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 gap-4">
                {/* Database children or fallback to hardcoded */}
                {parentMenu ? (
                  leftChildren.map((item) => {
                    const Icon = getItemIcon(menuKey, item.title, item.icon);
                    
                    // Alt menü öğesi için dinamik renkler (Parent'tan miras al)
                    const itemTextClass =
                      item.text_color && item.text_color.startsWith('text-')
                        ? item.text_color
                        : (getParentColor('text_color') || 'text-gray-900');
                        
                    const itemDescClass = 'text-gray-600'; // Açıklama her zaman gri
                    
                    // İkon rengi - Önce kendi, sonra parent, sonra default
                    const iconColorClass =
                      item.icon_color && item.icon_color.startsWith('text-')
                        ? item.icon_color
                        : (getParentColor('icon_color') || 
                           (getParentColor('hover_color') ? getParentColor('hover_color').replace('hover:', '') : null) ||
                           getIconColor(menuKey));
                    
                    // Hover background - Önce kendi, sonra parent, sonra default
                    const itemHoverBg = 
                      item.hover_bg_color && item.hover_bg_color.startsWith('hover:bg-')
                        ? item.hover_bg_color
                        : (getParentColor('hover_bg_color') || null);
                    
                    const hoverBgClass = itemHoverBg
                      ? `${itemHoverBg} ${itemHoverBg.replace('hover:bg-', 'hover:border-')}`
                      : getHoverBgClass(menuKey);

                    return (
                      <Link
                        key={item.id}
                        to={item.url || '#'}
                        onClick={() => setActiveMegaMenu(null)}
                        className={`group border border-gray-100 rounded-lg p-5 transition-colors text-center ${hoverBgClass}`}
                      >
                        <div className="mx-auto flex items-center justify-center">
                          <Icon className={`w-9 h-9 ${iconColorClass} group-hover:text-white`} />
                        </div>
                        <div className={`mt-3 text-sm font-semibold ${itemTextClass} group-hover:text-white`}>
                          {item.title}
                        </div>
                        {item.description && (
                          <p className={`mt-2 text-xs ${itemDescClass} group-hover:text-white/90`}>{item.description}</p>
                        )}
                      </Link>
                    );
                  })
                ) : (
                  ((data?.columns || []).flat() || []).map((item, idx) => (
                    <Link
                      key={idx}
                      to={resolvePath(menuKey, item.name, item.path)}
                      onClick={() => setActiveMegaMenu(null)}
                      className={`group border border-gray-100 rounded-lg p-5 transition-colors text-center ${getHoverBgClass(menuKey)}`}
                    >
                      {(() => { const Icon = getItemIcon(menuKey, item.name); return (
                        <div className="mx-auto flex items-center justify-center">
                          <Icon className={`w-9 h-9 ${getIconColor(menuKey)} group-hover:text-white`} />
                        </div>
                      ); })()}
                      <div className="mt-3 text-sm font-semibold text-gray-900 group-hover:text-white">
                        {item.name}
                      </div>
                      {item.description && (
                        <p className="mt-2 text-xs text-gray-600 group-hover:text-white/90">{item.description}</p>
                      )}
                    </Link>
                  ))
                )}
              </div>
            </div>
            {/* Sağ taraf - Liste formatında mobilde gizle, kart formatında göster */}
            {parentMenu ? (
              // Database right side
              isListFormat ? (
                // Liste formatı - Sadece masaüstünde göster
                rightChildren.length > 0 && (
                  <div className="hidden lg:block lg:col-span-3">
                    {/* Başlık öğeleri (is_header = true) - Parent'tan renk al */}
                    {rightChildren.filter(item => item.is_header).map((item) => {
                      const headerClass =
                        item.text_color && item.text_color.startsWith('text-')
                          ? item.text_color
                          : (getParentColor('text_color') || 'text-gray-900');
                      return (
                        <div key={item.id} className={`text-sm font-semibold mb-2 ${headerClass}`}>
                          {item.title}
                        </div>
                      );
                    })}
                    {/* Liste öğeleri (is_header = false) - Parent'tan renk al */}
                    <div className="space-y-2">
                      {rightChildren.filter(item => !item.is_header).map((item) => {
                        const baseTextClass =
                          item.text_color && item.text_color.startsWith('text-')
                            ? item.text_color
                            : (getParentColor('text_color') || 'text-gray-600');
                        const hoverClass =
                          item.hover_color && item.hover_color.startsWith('hover:')
                            ? item.hover_color
                            : (getParentColor('hover_color') || 'hover:text-purple-600');
                        return (
                          <Link 
                            key={item.id} 
                            to={item.url || '#'} 
                            onClick={() => setActiveMegaMenu(null)} 
                            className={`flex items-center text-sm ${baseTextClass} ${hoverClass}`}
                          >
                            <ArrowRight className="w-3 h-3 mr-2" />
                            {item.title}
                          </Link>
                        );
                      })}
                    </div>
                  </div>
                )
              ) : (
                // Kart formatı - Hem mobilde hem masaüstünde göster
                rightCardMenu && (
                  <div className="col-span-12 lg:col-span-3 mt-4 lg:mt-0">
                    <MenuCard 
                      menu={rightCardMenu} 
                      colors={{
                        ...rightCardMenu.promo_data?.colors,
                        // Parent menüden buton rengini al
                        ...getCardButtonColors(parentMenu)
                      }}
                    />
                  </div>
                )
              )
            ) : (
              // Fallback to hardcoded data
              <div className="col-span-12 lg:col-span-3">
                {data?.right?.links && (
                  <div className="hidden lg:block">
                    <div className="text-sm font-semibold text-gray-900 mb-2">{data.right.title}</div>
                    <div className="space-y-2">
                      {data.right.links.map((l, i) => (
                        <Link key={i} to={resolvePath(menuKey, l.label, l.path)} onClick={() => setActiveMegaMenu(null)} className="flex items-center text-sm text-gray-700 hover:text-purple-600">
                          <ArrowRight className="w-3 h-3 mr-2" />
                          {l.label}
                        </Link>
                      ))}
                    </div>
                  </div>
                )}
                {data?.right?.promo && (
                  <div className="mt-4 lg:mt-0">
                    <MenuCard 
                      menu={{
                        title: data.right.promo.titleLines[1],
                        url: data.right.promo.cta.path,
                        promo_data: {
                          upperTitle: data.right.promo.titleLines[0],
                          features: data.right.promo.features,
                          priceOriginal: data.right.promo.priceOriginal,
                          price: data.right.promo.price,
                          cta: data.right.promo.cta
                        }
                      }}
                      colors={parentMenu ? getCardButtonColors(parentMenu) : (menuKey === 'marketing' ? { buttonBg: '#e11d48', buttonHover: '#be185d' } : {})}
                    />
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  // İkon adından component'i al
  const getIconComponentByName = (iconName) => {
    const iconMap = {
      // Temel
      'Home': Home,
      'Menu': Menu,
      'Settings': Settings,
      'Search': Search,
      'Star': Star,
      
      // Bilgi & Yardım
      'HelpCircle': HelpCircle,
      'Info': Info,
      'AlertCircle': AlertCircle,
      'AlertTriangle': AlertTriangle,
      'CheckCircle': CheckCircle,
      'XCircle': XCircle,
      'Check': Check,
      
      // Teknoloji
      'Globe': Globe,
      'Server': Server,
      'Cpu': Cpu,
      'Database': Database,
      'Cloud': Cloud,
      'Wifi': Wifi,
      'Activity': Activity,
      'Terminal': Terminal,
      'Code': Code,
      
      // Güvenlik
      'Lock': Lock,
      'Shield': Shield,
      'ShieldCheck': ShieldCheck,
      'Key': Key,
      'BadgeCheck': BadgeCheck,
      
      // İletişim
      'Mail': Mail,
      'Phone': Phone,
      'MessageCircle': MessageCircle,
      'MessageSquare': MessageSquare,
      'Send': Send,
      'Bell': Bell,
      
      // E-ticaret & Finans
      'ShoppingCart': ShoppingCart,
      'Package': Package,
      'Truck': Truck,
      'CreditCard': CreditCard,
      'DollarSign': DollarSign,
      'Gift': Gift,
      
      // Tasarım & Medya
      'MonitorSmartphone': MonitorSmartphone,
      'Palette': Palette,
      'Camera': Camera,
      'Video': Video,
      'Mic': Mic,
      'Lightbulb': Lightbulb,
      
      // İçerik & Belgeler
      'FileText': FileText,
      'BookOpen': BookOpen,
      'File': File,
      'Folder': Folder,
      'Copy': Copy,
      'Paperclip': Paperclip,
      
      // İş & Organizasyon
      'Briefcase': Briefcase,
      'Users': Users,
      'Calendar': Calendar,
      'Clock': Clock,
      'Tag': Tag,
      'Bookmark': Bookmark,
      'Flag': Flag,
      
      // Eğitim & Büyüme
      'GraduationCap': GraduationCap,
      'Target': Target,
      'Rocket': Rocket,
      'TrendingUp': TrendingUp,
      'BarChart': BarChart,
      'Award': Award,
      'Crown': Crown,
      
      // Pazarlama & Sosyal
      'Megaphone': Megaphone,
      'Share2': Share2,
      'Heart': Heart,
      'Zap': Zap,
      
      // Navigasyon & Aksiyon
      'ChevronDown': ChevronDown,
      'ArrowRight': ArrowRight,
      'ExternalLink': ExternalLink,
      'Download': Download,
      'Upload': Upload,
      'RefreshCw': RefreshCw,
      'Repeat': Repeat,
      
      // Görünüm & Düzen
      'MapPin': MapPin,
      'Layers': Layers,
      'Grid': Grid,
      'List': List,
      'Filter': Filter
    };
    return iconMap[iconName] || null;
  };

  const getItemIcon = (menuKey, name, itemIcon = null) => {
    // Önce item'ın kendi icon alanını kontrol et
    if (itemIcon) {
      const IconComponent = getIconComponentByName(itemIcon);
      if (IconComponent) return IconComponent;
    }
    
    const n = (name || '').toLowerCase();
    // Exact-name maps for highest relevance
    const exactMaps = {
      domain: {
        'domain sorgulama': Search,
        '.tr alan adı': Tag,
        'belgesiz com.tr': Tag
      },
      website: {
        'kurumsal web sitesi': Globe,
        'kurumsal site tasarımları': Palette,
        'kolay site': MonitorSmartphone,
        'kolay site tasarımları': Palette,
        'e-ticaret': ShoppingCart,
        'e-ticaret tasarımları': Palette
      },
      hosting: {
        'sınırsız web hosting': Server,
        'wordpress hosting': Layers,
        'e-ticaret hosting': ShoppingCart,
        'bayi hosting': Users
      },
      email: {
        'xmail karşılaştır': Mail,
        'xmail pro': Mail,
        'xmail kurumsal': Mail
      },
      server: {
        'vps cloud server': Cpu,
        'vds server': Cpu,
        'dedicated server': Database,
        'kurumsal server': Server
      },
      ssl: {
        'tüm ssl sertifikaları': Shield,
        'hızlı kurulum (dv) ssl': BadgeCheck,
        'kurumsal (ov) ssl': ShieldCheck,
        'gelişmiş kurumsal (ev) ssl': Lock
      },
      marketing: {
        'seo hizmetleri': Search,
        'reklam yönetimi': Megaphone
      }
    };

    const menuExact = exactMaps[menuKey] || {};
    if (menuExact[n]) return menuExact[n];

    // Fallbacks by keywords
    switch (menuKey) {
      case 'domain':
        if (/transfer/.test(n)) return RefreshCw;
        if (/whois|sorgu/.test(n)) return Search;
        if (/com\.tr|\.tr|alan adı|domain/.test(n)) return Tag;
        return Globe;
      case 'website':
        if (/wordpress/.test(n)) return Layers;
        if (/e-?ticaret/.test(n)) return ShoppingCart;
        if (/tasarım/.test(n)) return Palette;
        return MonitorSmartphone;
      case 'hosting':
        if (/bayi/.test(n)) return Users;
        if (/mail/.test(n)) return Mail;
        if (/wordpress/.test(n)) return Layers;
        if (/ticaret/.test(n)) return ShoppingCart;
        return Server;
      case 'email':
        if (/pro|kurumsal/.test(n)) return Mail;
        return Users;
      case 'server':
        if (/vps|vds/.test(n)) return Cpu;
        if (/dedicated/.test(n)) return Database;
        return Server;
      case 'ssl':
        if (/dv/.test(n)) return BadgeCheck;
        if (/ov/.test(n)) return ShieldCheck;
        if (/ev/.test(n)) return Lock;
        if (/ssl/.test(n)) return Shield;
        return Shield;
      case 'marketing':
        if (/seo/.test(n)) return Search;
        if (/reklam|ads|ad/.test(n)) return Megaphone;
        if (/pazarlama|growth/.test(n)) return Target;
        return Rocket;
      default:
        return Check;
    }
  };

  const getIconColor = (menuKey) => {
    // Önce parent menüden renk çek
    const parentMenu = menus.find(m => {
      const mKey = m.menu_key || m.title.toLowerCase().replace(/\s+/g, '');
      return mKey === menuKey && m.parent_id === null;
    });
    
    if (parentMenu && parentMenu.icon_color) {
      return parentMenu.icon_color;
    }
    
    // Fallback: hover_color'dan text- prefix'ini çıkar
    if (parentMenu && parentMenu.hover_color) {
      return parentMenu.hover_color.replace('hover:', '');
    }
    
    // Son fallback: hardcoded
    switch (menuKey) {
      case 'domain':
      case 'website':
      case 'marka':
      case 'iletisim':
        return 'text-purple-600';
      case 'hosting':
      case 'knowledge-base':
        return 'text-blue-600';
      case 'server':
        return 'text-orange-600';
      case 'ssl':
        return 'text-green-600';
      case 'marketing':
        return 'text-rose-600';
      default:
        return 'text-gray-700';
    }
  };

  const getHoverBgClass = (menuKey) => {
    // Önce parent menüden renk çek
    const parentMenu = menus.find(m => {
      const mKey = m.menu_key || m.title.toLowerCase().replace(/\s+/g, '');
      return mKey === menuKey && m.parent_id === null;
    });
    
    if (parentMenu && parentMenu.hover_bg_color) {
      // hover_bg_color'dan border class'ı üret
      const borderClass = parentMenu.hover_bg_color.replace('hover:bg-', 'hover:border-');
      return `${parentMenu.hover_bg_color} ${borderClass}`;
    }
    
    // Son fallback: hardcoded (veritabanıyla uyumlu)
    switch (menuKey) {
      case 'domain':
      case 'website':
      case 'marka':
      case 'iletisim':
        return 'hover:bg-purple-600 hover:border-purple-600';
      case 'hosting':
      case 'knowledge-base':
        return 'hover:bg-blue-600 hover:border-blue-600';
      case 'server':
        return 'hover:bg-orange-600 hover:border-orange-600';
      case 'ssl':
        return 'hover:bg-green-600 hover:border-green-600';
      case 'marketing':
        return 'hover:bg-rose-600 hover:border-rose-600';
      default:
        return 'hover:bg-gray-700 hover:border-gray-700';
    }
  };

  const resolvePath = (menuKey, name, fallbackPath) => {
    const n = (name || '').toLowerCase();
    switch (menuKey) {
      case 'domain':
        return fallbackPath || '/alan-adi';
      case 'website':
        if (/hazır web sitesi tasarımları/.test(n)) return '/hazir-web-sitesi-tasarimlari';
        if (/hazır web sitesi/.test(n)) return '/kolay-site';
        if (/^e-ticaret$/.test(n)) return '/eticaret';
        if (/wordpress hosting/.test(n)) return '/wordpress-hosting';
        if (/e-?ticaret hosting/.test(n)) return '/eticaret-hosting';
        return fallbackPath || '/kolay-site';
      case 'hosting':
        if (/wordpress/.test(n)) return '/wordpress-hosting';
        if (/e-?ticaret/.test(n)) return '/eticaret-hosting';
        return fallbackPath || '/hosting';
      case 'email':
        return '/';
      case 'server':
        if (/vds/.test(n)) return '/vds-sunucu';
        if (/dedicated/.test(n)) return '/kurumsal-sunucu';
        if (/vps/.test(n)) return '/vps-sunucu';
        return fallbackPath || '/vps-sunucu';
      case 'ssl': {
        const nLower = (name || '').toLowerCase();
        if (/hızlı|hizli|dv/.test(nLower)) return '/ssl/ssl-sertifikasi?tab=dv';
        if (/kurumsal.*ov|ov\)/.test(nLower) || /kurumsal \(ov\)/.test(nLower)) return '/ssl/ssl-sertifikasi?tab=ov';
        if (/gelişmiş|gelismis|ev/.test(nLower)) return '/ssl/ssl-sertifikasi?tab=ev';
        if (/wildcard|subdomain/.test(nLower)) return '/ssl/ssl-sertifikasi?tab=wildcard';
        if (/fırsat|firsat|deal/.test(nLower)) return '/ssl/ssl-sertifikasi?tab=deals';
        return '/ssl/ssl-sertifikasi?tab=all';
      }
      case 'ecommerce':
        return '/eticaret';
      case 'marketing':
        if (/reklam/.test(n)) return '/reklam-yonetimi';
        if (/seo/.test(n)) return '/seo-hizmetleri';
        return fallbackPath || '/pazarlama-hizmetleri';
      default:
        return fallbackPath || '/';
    }
  };

  return (
    <header className="sticky top-0 z-40">
      {/* Main nav */}
      <div className="bg-white shadow-lg border-b border-gray-100">
        <div className="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <div className="flex items-center">
            <Link to="/" className="flex items-center group">
              <div className="h-12 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                <img
                  src={navbarLogoUrl || '/website-al-koyu.png'}
                  alt="Website Al"
                  className="w-[200px] h-full object-contain"
                />
              </div>
            </Link>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            {loading ? (
              <div className="text-gray-500">Yükleniyor...</div>
            ) : (
              <>
                {/* Ana menüleri order_index'e göre sıralı olarak render et */}
                {/* Domain ve SSL'i navbar'dan gizle - Hosting mega menu'sünde sekmeler olarak gösterilecek */}
                {menus
                  .filter(menu => {
                    if (menu.parent_id !== null || !menu.is_active) return false;
                    const menuKey = menu.menu_key || menu.title.toLowerCase().replace(/\s+/g, '');
                    // Domain ve SSL'i gizle, Hosting mega menu'sünde sekmeler olarak gösterilecek
                    return menuKey !== 'domain' && menuKey !== 'ssl';
                  })
                  .map((menu) => {
                    const menuKey = menu.menu_key || menu.title.toLowerCase().replace(/\s+/g, '');
                    const isMegaMenu = menu.is_mega_menu;
                    const menuStyle = getMenuStyle(menu);
                    const hoverAttrs = getHoverAttrs(menu);
                    const defaultHoverColor = menu.is_special 
                      ? 'hover:text-rose-600' 
                      : 'hover:text-purple-600';
                    const hoverColor = menu.hover_color && menu.hover_color.startsWith('hover:') 
                      ? menu.hover_color 
                      : (menu.hover_color ? '' : defaultHoverColor);
                    
                    if (isMegaMenu) {
                      // Hosting mega menu açıkken yeşil renk uygula
                      const isActive = activeMegaMenu === menuKey;
                      const activeColor = menuKey === 'hosting' && isActive ? 'text-green-600' : '';
                      
                      return (
                        <div key={menu.id} className="mega-menu-container">
                          <button 
                            onClick={() => handleMegaMenuClick(menuKey)} 
                            className={`flex items-center space-x-1 ${menuStyle.classes || 'text-gray-700'} ${isActive ? activeColor : ''} ${hoverColor} transition-colors font-medium py-8`}
                            style={menuStyle.style}
                            {...hoverAttrs}
                          >
                            <span>{menu.title}</span>
                            <ChevronDown className={`w-4 h-4 transition-transform duration-300 ${isActive ? 'rotate-180' : ''}`} />
                          </button>
                          {activeMegaMenu === menuKey && renderMega(menuKey)}
                        </div>
                      );
                    } else {
                      // Normal link (mega menu değil)
                      if (menu.is_special) {
                        // Özel stil (AI Chatbot gibi) - özel renkler varsa kullan
                        const specialStyle = menuStyle.style && Object.keys(menuStyle.style).length > 0 
                          ? menuStyle.style 
                          : {};
                        return (
                          <Link 
                            key={menu.id}
                            to={menu.url || '#'} 
                            className={`${menuStyle.classes || 'text-white bg-gradient-to-r from-yellow-400 via-pink-500 to-purple-700'} px-3 py-1.5 rounded-md font-medium`}
                            style={specialStyle}
                            {...hoverAttrs}
                          >
                            {menu.title}
                          </Link>
                        );
                      } else {
                        // Normal link
                        return (
                          <Link 
                            key={menu.id}
                            to={menu.url || '#'} 
                            className={`${menuStyle.classes || 'text-gray-700'} ${hoverColor} transition-colors font-medium`}
                            style={menuStyle.style}
                            {...hoverAttrs}
                          >
                            {menu.title}
                          </Link>
                        );
                      }
                    }
                  })
                }
              </>
            )}
          </nav>

          {/* Desktop Auth Buttons removed */}

          {/* Mobile menu button */}
          <Button
            variant="ghost"
            size="icon"
            className="lg:hidden"
            onClick={() => {
              setIsMenuOpen(!isMenuOpen);
              if (isMenuOpen) {
                setOpenMobileSubMenu(null);
              }
            }}
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </Button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="lg:hidden py-4 space-y-1 border-t border-gray-200 max-h-[70vh] overflow-y-auto">
            {/* Domain ve SSL'i mobil menüden de gizle - Hosting mega menu'sünde sekmeler olarak gösterilecek */}
            {menus
              .filter(menu => {
                if (menu.parent_id !== null || !menu.is_active) return false;
                const menuKey = menu.menu_key || menu.title.toLowerCase().replace(/\s+/g, '');
                return menuKey !== 'domain' && menuKey !== 'ssl';
              })
              .map((menu) => {
              // Mobilde sadece sol taraf menü öğelerini göster (sağ taraf liste gizli)
              const subMenus = menus.filter(m => 
                m.parent_id === menu.id && 
                (m.mega_menu_section === null || m.mega_menu_section === '' || m.mega_menu_section !== 'right')
              );
              const hasSubMenus = subMenus.length > 0;
              const menuKey = menu.menu_key || '';
              
              // İkon - Önce veritabanından, yoksa hardcoded
              const getMenuIcon = () => {
                // Veritabanından icon varsa onu kullan
                if (menu.icon) {
                  return getIconComponentByName(menu.icon);
                }
                
                // Fallback: menu_key'e göre hardcoded
                const iconMap = {
                  'domain': Globe,
                  'website': MonitorSmartphone,
                  'hosting': Server,
                  'server': Cpu,
                  'email': Mail,
                  'ssl': Lock,
                  'marketing': Megaphone,
                  'marka': BadgeCheck,
                  'brand': BadgeCheck,
                  'iletisim': Users,
                  'contact': Users,
                  'knowledge-base': BookOpen,
                  'blog': FileText,
                  'training': GraduationCap,
                  'ai-chatbot': Rocket,
                  'ai_chatbot': Rocket
                };
                return iconMap[menuKey] || null;
              };
              
              const IconComponent = getMenuIcon();
              const menuStyle = getMenuStyle(menu);
              const hoverAttrs = getHoverAttrs(menu);
              const defaultHoverColor = menu.is_special ? 'hover:text-rose-600' : 'hover:text-purple-600';
              const hoverColor = menu.hover_color && menu.hover_color.startsWith('hover:') 
                ? menu.hover_color 
                : (menu.hover_color ? '' : defaultHoverColor);

              // Özel sekme yapısı kontrolü - has_tabs kontrolü ile
              const hasTabsMobile = menu?.has_tabs === true || menu?.has_tabs === 1 || menu?.has_tabs === '1';
              
              let customTabsMobile = null;
              if (hasTabsMobile && menu.hosting_tabs) {
                let parsedTabs = null;
                if (typeof menu.hosting_tabs === 'string') {
                  try {
                    parsedTabs = JSON.parse(menu.hosting_tabs);
                  } catch (e) {
                    console.error('Error parsing hosting_tabs in mobile:', e);
                    parsedTabs = null;
                  }
                } else {
                  parsedTabs = menu.hosting_tabs;
                }
                
                // hosting_tabs yapısı: { tabs: {...}, right: {...} }
                if (parsedTabs) {
                  if (parsedTabs.tabs && typeof parsedTabs.tabs === 'object') {
                    customTabsMobile = parsedTabs.tabs;
                  } else if (typeof parsedTabs === 'object' && !parsedTabs.tabs) {
                    // Eğer direkt tabs objesi ise (eski format)
                    customTabsMobile = parsedTabs;
                  }
                }
              }
              
              if (hasTabsMobile || (menuKey === 'hosting' && !menu)) {
                // Tabs data'yı hazırla
                let tabsData = customTabsMobile;
                
                // Eğer has_tabs true ama tabs yoksa, normal menü göster
                if (hasTabsMobile && (!tabsData || Object.keys(tabsData).length === 0)) {
                  return null;
                }
                
                // Hosting için fallback to hardcoded data (sadece has_tabs false ise)
                if (menuKey === 'hosting' && !hasTabsMobile && (!tabsData || Object.keys(tabsData).length === 0)) {
                  tabsData = megaMenuData.hosting?.tabs;
                }
                
                if (!tabsData || Object.keys(tabsData).length === 0) {
                  // Normal menü olarak göster
                  return null;
                }
                
                const hostingData = {
                  tabs: tabsData
                };
                const isHostingOpen = openMobileSubMenu === menu.id;
                
                return (
                  <div key={menu.id}>
                    <button
                      onClick={() => setOpenMobileSubMenu(openMobileSubMenu === menu.id ? null : menu.id)}
                      className={`w-full flex items-center justify-between px-4 py-3 ${menuStyle.classes || 'text-gray-700'} ${isHostingOpen ? 'text-green-600' : ''} hover:bg-gray-50 font-medium ${hoverColor}`}
                      style={menuStyle.style}
                      {...hoverAttrs}
                    >
                      <div className="flex items-center gap-2">
                        {IconComponent && <IconComponent className="w-5 h-5" />}
                        <span>{menu.title}</span>
                      </div>
                      <ChevronDown 
                        className={`w-4 h-4 transition-transform ${isHostingOpen ? 'rotate-180' : ''}`}
                      />
                    </button>
                    
                    {/* Hosting sekmeleri - Mobil */}
                    {isHostingOpen && (
                      <div className="bg-gray-50 py-4 space-y-6">
                        {(() => {
                          // Sekmeleri order'a göre sırala (order yoksa 0 kabul et)
                          const sortedTabs = Object.keys(hostingData.tabs).map(tabKey => ({
                            key: tabKey,
                            tab: hostingData.tabs[tabKey],
                            order: hostingData.tabs[tabKey]?.order ?? 0
                          })).sort((a, b) => a.order - b.order);
                          
                          return sortedTabs.map(({ key: tabKey, tab }) => {
                            if (!tab || !tab.items || !Array.isArray(tab.items)) {
                              return null; // Geçersiz sekme, atla
                            }
                            
                            // Tab için ikon ve renkleri belirle
                            const TabIconMobile = tab.icon ? getIconComponentByName(tab.icon) : null;
                            
                            // Tab için renkleri belirle
                            const getTabIconColorMobile = () => {
                              if (tab.icon_color) {
                                if (tab.icon_color.startsWith('text-')) {
                                  return tab.icon_color;
                                } else if (tab.icon_color.startsWith('#')) {
                                  return { color: tab.icon_color };
                                }
                              }
                              // Icon ve renk için menuKey belirleme
                              let menuKeyForIcon = menuKey;
                              if (menuKey === 'hosting') {
                                menuKeyForIcon = tabKey === 'domain' ? 'domain' : (tabKey === 'ssl' ? 'ssl' : (tabKey === 'server' ? 'server' : 'hosting'));
                              } else {
                                menuKeyForIcon = tabKey;
                              }
                              return getIconColor(menuKeyForIcon);
                            };
                            
                            const getTabTitleColorMobile = () => {
                              if (tab.title_color) {
                                if (tab.title_color.startsWith('text-')) {
                                  return tab.title_color;
                                } else if (tab.title_color.startsWith('#')) {
                                  return { color: tab.title_color };
                                }
                              }
                              return 'text-gray-900';
                            };
                            
                            const iconColorMobile = getTabIconColorMobile();
                            const titleColorMobile = getTabTitleColorMobile();
                            const titleColorStyleMobile = typeof titleColorMobile === 'object' ? titleColorMobile : {};
                            const titleColorClassMobile = typeof titleColorMobile === 'string' ? titleColorMobile : '';
                            
                            // Icon ve renk için menuKey belirleme (fallback için)
                            let menuKeyForIcon = menuKey;
                            if (menuKey === 'hosting') {
                              menuKeyForIcon = tabKey === 'domain' ? 'domain' : (tabKey === 'ssl' ? 'ssl' : (tabKey === 'server' ? 'server' : 'hosting'));
                            } else {
                              menuKeyForIcon = tabKey;
                            }
                          
                          return (
                            <div key={tabKey} className="space-y-3 px-4">
                              {/* Sekme Başlığı */}
                              <h4 
                                className={`text-base font-bold ${titleColorClassMobile}`}
                                style={titleColorStyleMobile}
                              >
                                {tab.title || tabKey}
                              </h4>
                              
                              {/* Sekme İçeriği - Mobil Liste */}
                              <div className="space-y-2">
                                {tab.items.map((item, idx) => {
                                  // Icon öncelik sırası (mobil):
                                  // 1) item.icon
                                  // 2) getItemIcon (menuKey + isim)
                                  // 3) TabIconMobile (sekme için genel ikon)
                                  const ItemIcon =
                                    (item.icon ? getIconComponentByName(item.icon) : null) ||
                                    getItemIcon(menuKeyForIcon, item.name) ||
                                    TabIconMobile ||
                                    getItemIcon(menuKeyForIcon, item.name);
                                  
                                  // Icon rengi - Önce item.icon_color, sonra tab.icon_color, sonra default
                                  const getItemIconColorMobile = () => {
                                    // Önce item'ın kendi icon_color'unu kontrol et
                                    if (item.icon_color) {
                                      if (item.icon_color.startsWith('text-')) {
                                        return item.icon_color;
                                      } else if (item.icon_color.startsWith('#')) {
                                        return { color: item.icon_color };
                                      }
                                    }
                                    // Sonra tab'ın icon_color'unu kullan
                                    return iconColorMobile;
                                  };
                                  
                                  const itemIconColorMobileValue = getItemIconColorMobile();
                                  // Hover durumunda ikon rengi beyaz olacak, arka plan ikon rengi ile aynı
                                  const colorMapMobile = {
                                    'text-gray-700': '#374151',
                                    'text-white': '#ffffff',
                                    'text-gray-900': '#111827',
                                    'text-purple-600': '#9333ea',
                                    'text-blue-600': '#2563eb',
                                    'text-indigo-600': '#4f46e5',
                                    'text-emerald-600': '#059669',
                                    'text-green-600': '#16a34a',
                                    'text-rose-600': '#e11d48',
                                    'text-pink-600': '#db2777',
                                    'text-orange-600': '#ea580c',
                                    'text-amber-600': '#d97706',
                                    'text-yellow-600': '#ca8a04',
                                    'text-cyan-600': '#0891b2',
                                    'text-teal-600': '#0d9488'
                                  };
                                  
                                  let iconColorHexMobile = '#374151';
                                  if (typeof itemIconColorMobileValue === 'object' && itemIconColorMobileValue.color) {
                                    iconColorHexMobile = itemIconColorMobileValue.color;
                                  } else if (typeof itemIconColorMobileValue === 'string') {
                                    iconColorHexMobile = colorMapMobile[itemIconColorMobileValue] || '#374151';
                                  }
                                  
                                  const itemIconColorMobile = typeof itemIconColorMobileValue === 'object' 
                                    ? { 
                                        style: { ...itemIconColorMobileValue, color: iconColorHexMobile },
                                        className: 'flex-shrink-0'
                                      }
                                    : { 
                                        className: `flex-shrink-0 ${itemIconColorMobileValue}`,
                                        style: { color: iconColorHexMobile }
                                      };
                                  
                                  return (
                                    <Link
                                      key={idx}
                                      to={item.path || '#'}
                                      className="block px-2 py-3 bg-white rounded-lg border border-gray-200 transition-colors"
                                      style={{ '--hover-bg': iconColorHexMobile }}
                                      onMouseEnter={(e) => {
                                        e.currentTarget.style.backgroundColor = iconColorHexMobile;
                                        e.currentTarget.style.borderColor = iconColorHexMobile;
                                        const icon = e.currentTarget.querySelector('svg');
                                        if (icon) icon.style.color = '#ffffff';
                                        // Metin renklerini beyaz yap
                                        const textElements = e.currentTarget.querySelectorAll('.text-gray-900, .text-gray-500');
                                        textElements.forEach(el => {
                                          el.style.color = '#ffffff';
                                        });
                                      }}
                                      onMouseLeave={(e) => {
                                        e.currentTarget.style.backgroundColor = '';
                                        e.currentTarget.style.borderColor = '';
                                        const icon = e.currentTarget.querySelector('svg');
                                        if (icon) icon.style.color = iconColorHexMobile;
                                        // Metin renklerini eski haline döndür
                                        const textElements = e.currentTarget.querySelectorAll('.text-gray-900, .text-gray-500');
                                        textElements.forEach(el => {
                                          el.style.color = '';
                                        });
                                      }}
                                      onClick={() => {
                                        setIsMenuOpen(false);
                                        setOpenMobileSubMenu(null);
                                      }}
                                    >
                                      <div className="flex items-start gap-3">
                                        <div style={{ color: iconColorHexMobile }}>
                                          <ItemIcon className="w-5 h-5" style={{ color: iconColorHexMobile }} />
                                        </div>
                                        <div className="flex-1 min-w-0">
                                          <div className="font-medium text-sm text-gray-900">
                                            {item.name}
                                          </div>
                                          {item.description && (
                                            <div className="text-xs text-gray-500 mt-1">
                                              {item.description}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </Link>
                                  );
                                })}
                              </div>
                            </div>
                          );
                          });
                        })()}
                        
                        {/* Mobil - Sağ taraf alt menüleri */}
                        {(() => {
                          const rightChildren = menus
                            .filter(m => 
                              m.parent_id === menu.id && 
                              m.mega_menu_section === 'right'
                            )
                            .sort((a, b) => {
                              if (a.order_index !== b.order_index) {
                                return a.order_index - b.order_index;
                              }
                              return a.id - b.id;
                            });
                          
                          const isListFormatMobile = menu.is_list_format === true || menu.is_list_format === 1 || menu.is_list_format === '1';
                          
                          if (rightChildren.length > 0) {
                            if (isListFormatMobile) {
                              // Liste formatı
                              return (
                                <div className="px-4 space-y-3 mt-4 border-t pt-4">
                                  {/* Başlık öğeleri */}
                                  {rightChildren.filter(item => item.is_header).map((item) => {
                                    const headerClass =
                                      item.text_color && item.text_color.startsWith('text-')
                                        ? item.text_color
                                        : (menu.text_color || 'text-gray-900');
                                    return (
                                      <div key={item.id} className={`text-sm font-semibold ${headerClass}`}>
                                        {item.title}
                                      </div>
                                    );
                                  })}
                                  {/* Liste öğeleri */}
                                  <div className="space-y-2">
                                    {rightChildren.filter(item => !item.is_header).map((item) => {
                                      const baseTextClass =
                                        item.text_color && item.text_color.startsWith('text-')
                                          ? item.text_color
                                          : (menu.text_color || 'text-gray-600');
                                      const hoverClass =
                                        item.hover_color && item.hover_color.startsWith('hover:')
                                          ? item.hover_color
                                          : (menu.hover_color || 'hover:text-purple-600');
                                      return (
                                        <Link 
                                          key={item.id} 
                                          to={item.url || '#'} 
                                          onClick={() => {
                                            setIsMenuOpen(false);
                                            setOpenMobileSubMenu(null);
                                          }}
                                          className={`flex items-center text-sm ${baseTextClass} ${hoverClass}`}
                                        >
                                          <ArrowRight className="w-3 h-3 mr-2" />
                                          {item.title}
                                        </Link>
                                      );
                                    })}
                                  </div>
                                </div>
                              );
                            } else {
                              // Kart formatı - İlk kart öğesini göster
                              const rightCardMenu = rightChildren.find(item => item.promo_data || item.is_promo_card) || rightChildren[0];
                              if (rightCardMenu && (rightCardMenu.promo_data || rightCardMenu.is_promo_card)) {
                                return (
                                  <div className="px-4 mt-4 border-t pt-4">
                                    <MenuCard 
                                      menu={rightCardMenu} 
                                      colors={{
                                        ...rightCardMenu.promo_data?.colors,
                                        ...getCardButtonColors(menu)
                                      }}
                                    />
                                  </div>
                                );
                              }
                            }
                          }
                          
                          // Eğer rightChildren yoksa veya kart formatında kart bulunamadıysa, ana menünün promo_data'sını göster
                          if (!isListFormatMobile && menu.promo_data) {
                            return (
                              <div className="px-4 mt-4 border-t pt-4">
                                <MenuCard 
                                  menu={menu} 
                                  colors={{
                                    ...menu.promo_data?.colors,
                                    ...getCardButtonColors(menu)
                                  }}
                                />
                              </div>
                            );
                          }
                          
                          return null;
                        })()}
                        
                        {/* Mobil - Promo kartı (hosting_tabs.right.promo) */}
                        {hostingData.right?.promo && (
                          <div className="px-4 mt-4 border-t pt-4">
                            <MenuCard 
                              menu={{
                                title: hostingData.right.promo.titleLines?.[1] || '',
                                url: hostingData.right.promo.cta?.path || '#',
                                promo_data: {
                                  upperTitle: hostingData.right.promo.titleLines?.[0] || null,
                                  features: hostingData.right.promo.features || [],
                                  priceOriginal: hostingData.right.promo.priceOriginal || null,
                                  price: hostingData.right.promo.price || null,
                                  cta: hostingData.right.promo.cta || { label: '', path: '#' },
                                  colors: hostingData.right.promo.colors || {}
                                }
                              }}
                              colors={{
                                ...(hostingData.right.promo.colors || {}),
                                ...getCardButtonColors(menu)
                              }}
                            />
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                );
              }
              
              return (
                <div key={menu.id}>
                  {hasSubMenus ? (
                    // Menu with submenu - accordion style
                    <div>
                      <button
                        onClick={() => setOpenMobileSubMenu(openMobileSubMenu === menu.id ? null : menu.id)}
                        className={`w-full flex items-center justify-between px-4 py-3 ${menuStyle.classes || 'text-gray-700'} hover:bg-gray-50 font-medium ${hoverColor}`}
                        style={menuStyle.style}
                        {...hoverAttrs}
                      >
                        <div className="flex items-center gap-2">
                          {IconComponent && <IconComponent className="w-5 h-5" />}
                          <span>{menu.title}</span>
                        </div>
                        <ChevronDown 
                          className={`w-4 h-4 transition-transform ${openMobileSubMenu === menu.id ? 'rotate-180' : ''}`}
                        />
                      </button>
                      
                      {/* Submenu items */}
                      {openMobileSubMenu === menu.id && (
                        <div className="bg-gray-50 py-2">
                          {subMenus.map((subMenu) => {
                            // Alt menü ikonu - veritabanından veya ArrowRight
                            const SubIconComponent = subMenu.icon 
                              ? getIconComponentByName(subMenu.icon)
                              : null;
                            
                            // Alt menü için üst öğeden renk al
                            const subMenuTextColor = menuStyle.classes 
                              ? menuStyle.classes.split(' ').find(cls => cls.startsWith('text-')) || 'text-gray-600'
                              : 'text-gray-600';
                            
                            return (
                              <Link
                                key={subMenu.id}
                                to={subMenu.url || '#'}
                                className={`block px-11 py-2.5 text-sm ${subMenuTextColor} ${hoverColor} hover:bg-white transition-colors`}
                                style={menuStyle.style}
                                onClick={() => {
                                  setIsMenuOpen(false);
                                  setOpenMobileSubMenu(null);
                                }}
                              >
                                <div className="flex items-start gap-2">
                                  {SubIconComponent ? (
                                    <SubIconComponent className="w-4 h-4 mt-0.5 flex-shrink-0" />
                                  ) : (
                                    <ArrowRight className="w-4 h-4 mt-0.5 flex-shrink-0" />
                                  )}
                                  <div>
                                    <div className="font-medium">{subMenu.title}</div>
                                    {subMenu.description && (
                                      <div className="text-xs text-gray-500 mt-0.5">{subMenu.description}</div>
                                    )}
                                  </div>
                                </div>
                              </Link>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  ) : (
                    // Simple link without submenu
                    menu.is_special ? (
                      // AI Chatbot özel buton
                      <div className="px-4 py-2">
                        <Link
                          to={menu.url || '#'}
                          className={`flex items-center justify-center gap-2 px-4 py-3 ${menuStyle.classes || 'text-white bg-gradient-to-r from-yellow-400 via-pink-500 to-purple-700'} rounded-lg font-medium shadow-lg hover:shadow-xl transition-all`}
                          style={menuStyle.style}
                          {...hoverAttrs}
                          onClick={() => {
                            setIsMenuOpen(false);
                            setOpenMobileSubMenu(null);
                          }}
                        >
                          {IconComponent && <IconComponent className="w-5 h-5" />}
                          <span>{menu.title}</span>
                        </Link>
                      </div>
                    ) : (
                      // Normal link
                      <Link
                        to={menu.url || '#'}
                        className={`flex items-center gap-2 px-4 py-3 font-medium ${menuStyle.classes || 'text-gray-700'} hover:bg-gray-50 ${hoverColor} transition-colors`}
                        style={menuStyle.style}
                        {...hoverAttrs}
                        onClick={() => {
                          setIsMenuOpen(false);
                          setOpenMobileSubMenu(null);
                        }}
                      >
                        {IconComponent && <IconComponent className="w-5 h-5" />}
                        <span>{menu.title}</span>
                      </Link>
                    )
                  )}
                </div>
              );
            })}
          </div>
        )}
        </div>
      </div>
    </header>
  );
};

export default FixedMegaMenuHeader;